import type { ITopic } from '@dakedake/types'
import { topicList } from '@/services'
import { useCallback, useState } from 'react'

export default function useList() {
  const [data, setdData] = useState<ITopic[]>()

  const getTopicList = useCallback(async () => {
    const res = await topicList({ pageSize: 100 })
    setdData(res.data?.list)
  }, [])

  return {
    topicList: data,
    getTopicList
  }
}
